import { useSelector } from 'react-redux';
import * as R from 'ramda';

import { PosPlugin } from 'plugins/plugin';
import { getDynamicTipProduct } from 'plugins/customerDisplay/rdx/reducer';
import { reactcursively } from 'utils/react';

const UIProductBasePriceInProductOrderEdit: PosPlugin['UIProductBasePriceInProductOrderEdit'] = ({
  order,
  children,
}) => {
  const { orderIndex } = order;
  const dynamicTipProduct = useSelector(getDynamicTipProduct);
  const shouldBeDisabled = !!(
    orderIndex && Number(orderIndex) === dynamicTipProduct?.orderIndex
  );
  const disableIfDynamicTip = shouldBeDisabled
    ? R.assocPath(['props', 'disabled'], true)
    : R.identity;
  return reactcursively(
    R.when(
      R.pathEq(['props', 'data-testid'], 'base_price_input'),
      disableIfDynamicTip,
    ),
  )(children);
};

export default UIProductBasePriceInProductOrderEdit;
